import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { RiEdit2Fill } from "react-icons/ri";

export default function Table(props) {
  const { theadTable, data } = props;

  return (
    <Content>
      <table className="table">
        <thead>
          <tr>
            {theadTable && (
              <>
                {theadTable.map((dt, index) => (
                  <th scope="col" key={index}>
                    {dt}
                  </th>
                ))}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((datum, index) => {
            return (
              <tr key={datum.id}>
                <td>
                  <img
                    src={
                      datum.logo ||
                      "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
                    }
                    style={{ width: "40px", borderRadius: "3px" }}
                    alt=""
                  />
                </td>
                {theadTable.map((header, index) => (
                  <>
                    <td key={index}>
                      <span>{datum[header]}</span>
                    </td>
                  </>
                ))}
                <td>
                  {datum.premium ? (
                    <span className="badge bg-success">Premium</span>
                  ) : (
                    <span className="badge bg-warning">No Premium</span>
                  )}
                </td>

                <td onClick={() => props.openEditRestaurant(datum)}>
                  <RiEdit2Fill
                    style={{ fontSize: "1.4em", cursor: "pointer" }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Content>
  );
}

const Content = styled.div`
  .table {
    font-weight: bold;
    font-size: 1em;
  }

  .table-hover tbody tr:hover {
    background-color: rgba(122, 114, 81, 0.7);
    color: rgb(112, 24, 78);
  }

  thead {
    background-color: #34495e;
    color: white;
    border-bottom: 2px solid #34495e !important;
  }
`;

// eslint-disable-next-line react/no-typos
Table.PropTypes = {
  theadTable: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
};
